import axiosClient from "../api/axios-client";

/**
 * Désabonne CET appareil des notifications push : supprime la ligne côté
 * serveur, puis libère l'abonnement dans le navigateur.
 *
 * À appeler AVANT `POST /logout` — la suppression de la ligne passe par une
 * route authentifiée, et le jeton n'existe plus après.
 *
 * Renvoie `false` si rien n'était abonné. Laisse remonter les erreurs : le
 * panneau des préférences de notification en dépend pour afficher son message
 * d'échec. C'est aux chemins de déconnexion de les avaler.
 *
 * ⚠️ On passe par `getRegistration()` et JAMAIS par
 * `navigator.serviceWorker.ready` : `ready` ne se résout jamais tant qu'aucun
 * service worker n'est enregistré — le cas de la quasi-totalité des
 * utilisateurs, qui n'ont jamais activé les notifications. L'attendre dans un
 * chemin de déconnexion la gèlerait sans qu'aucun `catch` ni `finally` ne
 * puisse rattraper l'attente.
 */
export async function detachCurrentPushSubscription(): Promise<boolean> {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return false;

    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    if (!subscription) return false;

    await axiosClient.delete("/web-push/unsubscribe", {
        data: { endpoint: subscription.endpoint },
    });

    await subscription.unsubscribe();

    return true;
}
